export function lockedCalendarDragMessage(eventType?: string | null) {
  if (eventType === "pausa") return "Esta pausa se edita desde sucursales."
  if (eventType === "time_block") return "Este evento se edita en Google Calendar."
  if (eventType === "overlap_group") return "Elige una cita de la lista para moverla."
  return null
}
